import "./Bubble.css";

function Bubble({ component1, component2, component3 }) {
  return (
    <div className="bubble-container">
      {component1}
      {component2}
      {component3}
    </div>
  );
}

export default Bubble;
